import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsOfUseModal } from './TermsOfUseModal';
import { CookiesPolicyModal } from './CookiesPolicyModal';
export function Footer() {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isCookiesModalOpen, setIsCookiesModalOpen] = useState(false);
  return <footer className="bg-slate-950 text-slate-400 py-16 border-t border-slate-800" data-id="element-85">
      <div className="container mx-auto px-4 md:px-6" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-87">
          <div className="col-span-1 md:col-span-1" data-id="element-88">
            <div className="mb-6" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/qfdEx4fYG73g9WHAKcydMH/logo_ticketmaestro_negativo.png" alt="TicketMaestro" className="h-8 w-auto" data-id="element-90" />
            </div>
            <p className="text-sm leading-relaxed mb-6" data-id="element-91">
              Transformando la experiencia con tecnología de vanguardia.
            </p>
          </div>

          <div data-id="element-92">
            <h3 className="text-white font-semibold mb-6" data-id="element-93">Contacto</h3>
            <ul className="space-y-4 text-sm" data-id="element-94">
              <li className="flex items-center gap-3" data-id="element-95">
                <Mail size={16} className="text-indigo-500" data-id="element-96" />
                <a href="mailto:contacto@ticketmaestro.net" className="hover:text-white transition-colors" data-id="element-97">
                  contacto@ticketmaestro.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-98">
          <p data-id="element-99">
            &copy; {new Date().getFullYear()} TicketMaestro. Todos los derechos
            reservados.
          </p>
          <div className="flex flex-wrap gap-4 md:gap-6" data-id="element-100">
            <button onClick={() => setIsPrivacyModalOpen(true)} className="hover:text-white transition-colors text-left" data-id="element-101">
              Privacidad y Protección de Datos
            </button>
            <button onClick={() => setIsTermsModalOpen(true)} className="hover:text-white transition-colors text-left" data-id="element-102">
              Términos de Uso
            </button>
            <button onClick={() => setIsCookiesModalOpen(true)} className="hover:text-white transition-colors text-left" data-id="element-103">
              Cookies
            </button>
          </div>
        </div>
      </div>

      <PrivacyPolicyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} data-id="element-104" />
      <TermsOfUseModal isOpen={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} data-id="element-105" />
      <CookiesPolicyModal isOpen={isCookiesModalOpen} onClose={() => setIsCookiesModalOpen(false)} data-id="element-106" />
    </footer>;
}